/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuFilterDeliveryOptions_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenuFilterDeliveryOptions_viewer$ref: FragmentReference;
export type SbRespRefineMenuFilterDeliveryOptions_viewer = {|
  +$fragmentRefs: SbSharedRefineMenuFilterDeliveryOptions_viewer$ref,
  +$refType: SbRespRefineMenuFilterDeliveryOptions_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterDeliveryOptions_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterDeliveryOptions_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '09e4498fa17facd46ea50d2acd0b82cb';
module.exports = node;
